import { createSlice } from '@reduxjs/toolkit';
export interface DataState {
  errors: any;
  
}
const initialState: DataState = {
  errors:[]
};

export const errormessageSlice = createSlice({
  name: 'errorList',
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
  },
});
export const { setErrors } =
errormessageSlice.actions;
export default errormessageSlice.reducer;
